module.exports = __webpack_public_path__ + "static/media/sign_up_background.fe380557.png";